<simple-notifications></simple-notifications>


<div class="blue-bg">
  <div class="max-page-width">
    <div class="container-fluid searchbg">
      <div class="searchShadow">
        <div class="searchFormbg">
          <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <!-- <div class="col-lg-2 easyRent-btn">
                                <p>{{ 'Easyrent2' | translate }}</p>
                                <div class="custom-control custom-switch custom-switch-additional">
                                    <input type="checkbox" class="custom-control-input" id="customSwitches8">
                                    <label class="custom-control-label" for="customSwitches8"></label>
                                </div>
                            </div> -->
              <div class="col-lg-11 col-md-10 p-0">
                <div class="row">
                  <div class="form-group col-lg-5 pl-3 border-right">
                    <label>{{ 'PickupLocation' | translate }}</label>
                    <div class="input-group">
                      <span class="input-group-prepend">
                        <span class="input-group-text">
                          <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                        </span>
                      </span>
                      <!-- <input ngx-google-places-autocomplete [options]='options' formControlName="location"
                        class="form-control" placeholder="{{ 'EnterLocation' | translate }}" #placesRef="ngx-places"
                        (onAddressChange)="handleAddressChange($event)"
                        [ngClass]="{ 'is-invalid': submitted && f.location.errors }" /> -->





                            <mat-google-maps-autocomplete class=" autocomplete-filed"
                            [ngClass]="{ 'is-invalid': submitted && f.location.errors }"

                            addressLabelText=""
                            placeholderText="{{ 'EnterLocation' | translate }}"
                            appearance="none"

                            [address]="currentLocationFormatedAdress"
                            requiredErrorText=""
                            invalidErrorText=""
                          (onAutocompleteSelected)=" onAutocompleteSelected($event)">
                          </mat-google-maps-autocomplete>




                      <!-- <input placeholder="Amman Airport (AMM), Amman, Jordan" type="text"
                                        formControlName="location" class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.location.errors }" /> -->
                    </div>

                    <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                      <div *ngIf="f.location.errors.required"></div>
                    </div>
                  </div>
                  <div class="form-group col-lg-3 col-md-6 border-right pl-2">
                    <label>{{ 'PickupDate' | translate }}</label>
                    <div class="row">
                      <div class="col-6">
                        <div class="pick-up-date">
                          <mat-form-field appearance="none">
                            <mat-datepicker-toggle matPrefix [for]="PickUpDate"></mat-datepicker-toggle>
                            <mat-datepicker panelClass="select-calender-home" #PickUpDate></mat-datepicker>
                            <input readonly placeholder=" " formControlName="PickUpDate" matInput
                              [min]="minPickUpDate" [matDatepicker]="PickUpDate" (click)="PickUpDate.open()"
                              (dateInput)="addEvent(1,'input', $event)"
                              (dateChange)="addEvent(1,'change', $event);dropUpDate.open()">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="pick-up-time">
                          <input [placeholder]="minTime" formControlName="PickUpTime" id="pickUpTime"
                            class="form-control" [ngClass]="{'is-invalid':submitted&&f.PickUpTime.errors}" />
                        </div>

                      </div>
                    </div>


                  </div>
                  <div class="form-group col-lg-3 col-md-6 pl-2 ">
                    <label>{{ 'ReturnDate' | translate }} </label>
                    <div class="row">
                      <div class="col-6">
                        <div class="drop-off-date">
                          <mat-form-field appearance="none">
                            <mat-datepicker-toggle matPrefix [for]="dropUpDate"></mat-datepicker-toggle>
                            <mat-datepicker panelClass="select-calender-home" #dropUpDate></mat-datepicker>
                            <input placeholder=" " readonly (dateInput)="addEvent(2,'input', $event)"
                              (dateChange)="addEvent(2,'change', $event);dropUpDate.open()" formControlName="dropUpDate"
                              matInput [min]="minDropOffDate" [matDatepicker]="dropUpDate" (click)="dropUpDate.open()">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="drop-off-time">
                          <input placeholder="12:00am" formControlName="dropUpTime" id="dropUpTime" class="form-control"
                            [ngClass]="{'is-invalid':submitted&&f.dropUpTime.errors}" />
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>

              <div class="col-lg-1 col-md-2 text-right pr-0">
                <button type="submit" class="btn search-btn login-btn">{{ 'FindBtn' | translate }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="text-center ready-drive-text">
        <h3>{{ 'ReadyToDriveDesc' | translate }}</h3>
      </div>

      <div *ngIf="easyRentSection" class="easy-rent-section">
        <div class="eazyRent text-center">
          <a class="text-center" pageScroll href="#eazyRentPart">
            <img class="d-block" src='assets/img/eazyRent.svg' />
            <fa-icon class="d-block vert-move" [icon]="faChevronDown"></fa-icon>
          </a>
        </div>
      </div>

    </div>
  </div>
</div>
